import React, { useEffect, useState } from "react";
import AddComponents from "./AddComponents";
import UseToggle from "../../../Hooks/UseToggle";
import ModeWiseCDISCGraph from "./ModeWiseCDISCGraph";
import CDISCRecentActivity from "./CDISCRecentActivity";
import { useParams } from "react-router";
import { BiSolidDashboard } from "react-icons/bi";
import { Card, Col, Container, Form, Row } from "react-bootstrap";
import { PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyEDCDashboardGraph } from "../../../APIServices/studyEDCDashboardGraph";

const CDISCDashboard = () => {
  const toggles = UseToggle();
  const { studyId } = useParams();
  const [greeting, setGreeting] = useState("");
  const [selected, setSelected] = useState([]);
  const category = JSON.parse(localStorage.getItem("role"));
  const [dashboardLoader, setDashboardLoader] = useState(false);
  const userName = JSON.parse(localStorage.getItem("firstName"));
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getGreeting = () => {
    const currentTime = new Date().getHours();
    let greeting;
    if (currentTime >= 5 && currentTime < 12) greeting = "Good Morning";
    else if (currentTime >= 12 && currentTime < 18) greeting = "Good Afternoon";
    else greeting = "Good Evening";
    setGreeting(greeting);
  };

  const getStudyDashboardComponentData = async () => {
    setDashboardLoader(true);
    let data = await studyEDCDashboardGraph.getStudyDashboardComponentData(
      studyId,
      category,
      StudyMode
    );
    setSelected(data?.data || []);
    setDashboardLoader(false);
  };

  useEffect(() => {
    getGreeting();
    getStudyDashboardComponentData();
  }, [studyId]);

  return (
    <>
      <div className="chart__overview">
        <div className="hstack gap-2 p-1 justify-content-end border-bottom">
          <button
            title="Edit Chart"
            className="updateProfile hstack gap-1"
            onClick={() => toggles.setToggle()}
          >
            <BiSolidDashboard /> Add Component
          </button>
        </div>
        <div className="text-center py-2 border-bottom">
          <h5 className="m-0">
            {greeting}! {userName}
          </h5>
          <p className="m-0">Welcome to Your CDISC Dashboard.</p>
        </div>
        {dashboardLoader ? (
          <PageLoader />
        ) : (
          <Container fluid>
            <Row>
              <Form.Group
                as={Col}
                md={selected.includes("Recent activity") ? 8 : 12}
                className="overflow-auto border-end pt-2 p-0"
                style={{ height: "calc(100vh - 245px)" }}
              >
                {/* <ModeWiseCDISCGraph selected={selected} StudyMode={StudyMode}/> */}
              </Form.Group>
              {selected.includes("Recent activity") && (
                <Form.Group as={Col} sm={4} className="pt-2">
                  <Card className="border bg-light">
                    <Card.Body>
                      <Card.Title>Recent activity</Card.Title>
                      <Card.Text className="m-0 mt-2">
                        <div
                          className="overflow-auto"
                          style={{ height: "calc(100vh - 325px)" }}
                        >
                          <CDISCRecentActivity StudyMode={StudyMode} />
                        </div>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Form.Group>
              )}
            </Row>
          </Container>
        )}
      </div>
      <AddComponents
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        studyId={studyId}
        category={category}
        StudyMode={StudyMode}
        selected={selected}
        setSelected={setSelected}
        getStudyDashboardComponentData={getStudyDashboardComponentData}
      />
    </>
  );
};

export default CDISCDashboard;
